import { FC, useMemo, useState } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import Icon from '../../Icons/Icon';
import styles from './NavAccordion.module.css';

interface NavAccordionProps {
  sublinks: NavLinkProps[];
  title: string;
  defaultOpen?: boolean;
}

const NavAccordion: FC<NavAccordionProps> = ({ title, sublinks, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleClick = () => {
    setIsOpen((prevState) => !prevState);
  };

  const renderSublinks = useMemo(
    () =>
      sublinks.map((sublink, index) => (
        <li key={typeof sublink.to === 'string' ? sublink.to : sublink.to.pathname}>
          <NavLink {...sublink} />
          {index === sublinks.length - 1 && <div className={styles.borderBottom} />}
        </li>
      )),
    [sublinks],
  );

  return (
    <li className={styles.navAccordion}>
      <button onClick={handleClick} className={styles.accordionTitle} aria-expanded={isOpen} type="button">
        {title}
        <Icon iconName={isOpen ? 'ChevronUp' : 'ChevronDown'} />
      </button>
      {isOpen && <ul className={styles.sublinks}>{renderSublinks}</ul>}
    </li>
  );
};

export default NavAccordion;
